/* Joy of Small Things — lightweight wishlist hearts.
   Saves product ids in localStorage on this device only.
   No account, no app: the heart simply remembers what a shopper saved. */
(function () {
  var KEY = 'jost-wishlist';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable — hearts still toggle for this view */
    }
  }

  function paintAll() {
    var list = read();
    document.querySelectorAll('[data-jost-wish]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-jost-wish')) !== -1;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-jost-wish]') : null;
    if (!btn) return;
    event.preventDefault();
    var id = btn.getAttribute('data-jost-wish');
    var list = read();
    var idx = list.indexOf(id);
    if (idx === -1) {
      list.push(id);
    } else {
      list.splice(idx, 1);
    }
    write(list);
    paintAll();
  });

  /* Facet filtering swaps the grid HTML in place — repaint when new cards arrive. */
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        paintAll();
        break;
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll);
  } else {
    paintAll();
  }
})();

/* Header saved-pieces panel (Quince-style header heart). */
(function () {
  var KEY = 'jost-wishlist';
  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var openBtn = document.querySelector('.jost-wish-open');
  var panel = document.querySelector('.jost-wish-panel');
  var listEl = document.querySelector('.jost-wish-panel__list');
  var emptyEl = document.querySelector('.jost-wish-panel__empty');
  var countEl = document.querySelector('.jost-wish-count');
  if (!openBtn || !panel || !listEl) return;
  var cache = null;
  function paintCount() {
    var n = read().length;
    if (countEl) {
      countEl.textContent = n;
      countEl.hidden = n === 0;
    }
  }
  function loadProducts(cb) {
    if (cache) return cb(cache);
    fetch('/products.json?limit=250')
      .then(function (r) {
        return r.json();
      })
      .then(function (d) {
        cache = {};
        (d.products || []).forEach(function (p) {
          cache[String(p.id)] = p;
        });
        cb(cache);
      })
      .catch(function () {
        cb({});
      });
  }
  function render() {
    paintCount();
    var ids = read();
    listEl.innerHTML = '';
    if (!ids.length) {
      emptyEl.hidden = false;
      return;
    }
    emptyEl.hidden = true;
    loadProducts(function (map) {
      listEl.innerHTML = '';
      ids.forEach(function (id) {
        var p = map[String(id)];
        if (!p) return;
        var li = document.createElement('li');
        li.className = 'jost-wish-panel__item';
        var img = p.images && p.images[0] ? p.images[0].src : '';
        li.innerHTML =
          (img
            ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=96" alt="">'
            : '') +
          '<a href="/products/' +
          esc(p.handle) +
          '">' +
          esc(p.title) +
          '</a>' +
          '<button type="button" class="jost-wish-panel__remove" data-jost-remove="' +
          p.id +
          '" aria-label="Remove ' +
          esc(p.title) +
          '">&times;</button>';
        listEl.appendChild(li);
      });
      if (!listEl.children.length) emptyEl.hidden = false;
    });
  }
  openBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    var willOpen = panel.hidden;
    panel.hidden = !willOpen;
    openBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (willOpen) render();
  });
  document.addEventListener('click', function (e) {
    if (!panel.hidden && !(e.target.closest && e.target.closest('.jost-wish-header'))) {
      panel.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) {
      panel.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var rm = e.target.closest('[data-jost-remove]');
    if (rm) {
      var id = rm.getAttribute('data-jost-remove');
      write(
        read().filter(function (x) {
          return String(x) !== String(id);
        })
      );
      document.querySelectorAll('[data-jost-wish]').forEach(function (b) {
        if (String(b.getAttribute('data-jost-wish')) === String(id)) {
          b.setAttribute('aria-pressed', 'false');
        }
      });
      render();
      return;
    }
    if (e.target.closest('[data-jost-wish]')) {
      setTimeout(paintCount, 0);
    }
  });
  paintCount();
})();
